import { render, staticRenderFns } from "./MapPointReviewCreate.vue?vue&type=template&id=a4b6f6f2&"
import script from "./MapPointReviewCreate.vue?vue&type=script&lang=js&"
export * from "./MapPointReviewCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VFileInput,VRating})
